<template>
    <div class="newsletter">
        <b-container fluid>
            <b-row>
                <b-col class="text-center mb-1 mt-2">
                    <b>Rimani aggiornato sulle nuove massime e commenti</b>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-form-checkbox v-model="newsletterCommenti" @change="updateNewsletterCommenti()">
                        Ricevi l'email settimanale
                    </b-form-checkbox>
                </b-col>
            </b-row>
            <hr />
            <b-row>
                <b-col>
                    <h3>Newsletter - Sentenze di Merito</h3>
                </b-col>
            </b-row>
            <b-row class="sfondo-giustup">
                <b-col class="text-center mb-3 mt-2">
                    <b>Aggiungi i parametri di ricerca per i quali desideri ricevere un'email periodica con le ultime sentenze inserite.</b>
                </b-col>
            </b-row>
            <b-row class="sfondo-giustup">
                <b-col>
                    Testo
                    <b-form-input class="text-center mt-3" placeholder="Testo della ricerca" v-model="form.testo" size="sm" type="text"></b-form-input>
                </b-col>
            </b-row>
            <b-row class="pt-4 sfondo-giustup">
                <b-col sm="12" md="4">
                    Categoria
                    <b-form-select :options="data.materie1" @change="changeMateria1" v-model="filterMaterie.liv1" size="sm">
                        <template v-slot:first>
                            <option :value="``">Qualsiasi</option>
                        </template>
                    </b-form-select>
                </b-col>
                <b-col sm="12" md="4">
                    Materia
                    <b-form-select :options="data.materie2" @change="changeMateria2" v-model="filterMaterie.liv2" size="sm">
                        <template v-slot:first>
                            <option :value="``">Qualsiasi</option>
                        </template>
                    </b-form-select>
                </b-col>
                <b-col sm="12" md="4">
                    Sottomateria
                    <b-form-select :options="data.materie" v-model="form.materia" size="sm">
                        <template v-slot:first>
                            <option :value="``">Qualsiasi</option>
                        </template>
                    </b-form-select>
                </b-col>
            </b-row>
            <b-row class="sfondo-giustup">
                <b-col class="text-center mt-4">            
                    Organo giudiziario
                </b-col>
            </b-row>
            <b-row class="sfondo-giustup">
                <b-col>            
                    <b-form-select v-model="form.organo" size="sm">
                        <template v-slot:first>
                            <option :value="``">Qualsiasi</option>
                        </template>
                        <option v-for="trib of data.tribunali" :key="trib.key" :value="trib.key">{{trib.value}}</option>
                    </b-form-select>
                </b-col>
            </b-row>
            <!--<b-row>
                <b-col class="mt-4">            
                    <b-form-checkbox v-model="trattamento">
                        Acconsento al trattamento dei dati.
                        <a href="https://landing.giustup.it/giustupprivacynewsletter" target="_blank">Informativa privacy</a>
                    </b-form-checkbox>
                </b-col>
            </b-row>-->
            <b-row class="sfondo-giustup">
                <b-col class="mt-2 mb-2">            
                    <b-button variant="success" @click="addMateria()">Aggiungi alle newsletter</b-button>
                </b-col>
            </b-row>
            <hr />
            <b-row>
                <b-col class="text-center my-3">
                    <b>Iscrizioni attuali:</b>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="mt-2 mb-3">            
                    <b-table striped hover :items="materieTable.items" :fields="materieTable.fields" :show-empty="true" empty-text="Nessuna iscrizione alle newsletter!">
                        <template v-slot:cell(select)="data">
                            <b-button variant="danger" size="sm" @click="delMateria(data.item)">Elimina</b-button>
                        </template>
                    </b-table>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import apiSearch from '../../services/search.js'
import api from '../../services/service.js'

export default {
  name: 'newsletter',
  data () {
    return {
        materieTable: {
            fields: [
                {
                    key: 'testoRicerca',
                    label: 'Testo',
                    sortable: true
                },
                {
                    key: 'materia1livello',
                    label: 'Categoria',
                    sortable: true
                },
                {
                    key: 'materia2livello',
                    label: 'Materia',
                    sortable: true
                },
                {
                    key: 'materia',
                    label: 'Sottomateria',
                    sortable: true
                },
                {
                    key: 'tribunale',
                    label: 'Tribunale',
                    sortable: true
                },
                {
                    key: 'select',
                    label: '',
                    sortable: false
                }
            ],
            items: []
        },
        trattamento: true,
        data: {
            tribunali: [],
            materie: [],
            materie1: [],
            materie2: []
        },
        filterMaterie: {
            liv1: '',
            liv2: '',
        },
        form: {
            materia: '',
            organo: '',
            testo: ''
        },
        newsletterCommenti: ''
    }
  },
  methods: {
    changeMateria1(value) {
        let data = {
            liv1: this.filterMaterie.liv1
        };
        apiSearch.getMaterie(data).then((data) => {
            this.data.materie2 = data;
        });
    },
    changeMateria2(value) {
        apiSearch.getMaterie(this.filterMaterie).then((data) => {
            this.data.materie = data;
        });
    },
    addMateria() {
        //check params
        let errMsg = null;
        if(!this.trattamento)
            errMsg = "Il consenso al trattamento dei dati è obbligatorio!";
        
        if(errMsg != null){
            alert(errMsg);
            return;
        }

        //send request      
        api.execute('post', 'newsletter', this.form, true).then((data) => {
            if(data.status === 201){
                this.getMaterie();
            }
            else {
                alert("Errore nell'inserimento della materia!");
            }
        });
    },
    async getMaterie() {
        this.materieTable.items = await api.execute('get', 'newsletter');
    },
    delMateria(item) {
        let data = {
            materia: item.materiaCodice,
            organo: item.tribunaleCodice,
            testo: item.testoRicerca
        };
        api.execute('post', 'newsletter/elimina', data, true).then((data) => {
            if(data.status === 204){
                this.getMaterie();
            }
            else {
                alert("Errore nell'eliminazione della materia!");
            }
        });
    },
    loadCampi(){
        let materia = this.$route.params.materia;
        if(materia !== undefined){
            this.filterMaterie.liv1 = materia.substring(0, 1);
            this.filterMaterie.liv2 = materia.substring(0, 3);
            this.form.materia = materia;
            this.changeMateria1();
            this.changeMateria2();
        }

        let tribunale = this.$route.params.tribunale;
        if(tribunale !== undefined)
            this.form.organo = tribunale;

        let testo = this.$route.params.testo;
        if(testo !== undefined)
            this.form.testo = testo;
    },
    async getNewsletterCommenti(){
      let data = await api.execute('get', 'newsletter/newslettercommenti');
      
      this.newsletterCommenti = data;
    },
    updateNewsletterCommenti(){
      api.execute('put', 'newsletter/newslettercommenti');
    }
  },
  async created() {
    this.data.tribunali = await apiSearch.getTribunali();
    this.data.materie1 = await apiSearch.getMaterie(this.filterMaterie)
    
    await this.getMaterie();
    this.loadCampi();

    await this.getNewsletterCommenti();

    this.$parent._data.loaded = true;
  },
  watch:{
    $route (to, from){
        if(to.name === "Newsletter"){
            this.loadCampi();
        }
    }
  }
}
</script>

<style>

.sfondo-giustup {
  background-color: #008bc0;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Newsletter/Newsletter.vue